import FilesList from "../FilesList";
import InfoGroup from "../InfoGroup";

const filesList = [
    {
        id: 0,
        name: 'filename.png',
        link: '/file.png',
    },
    {
        id: 1,
        name: 'file.jpg',
        link: '/file.jpg',
    },
]


export const UPtableFields = [
    {
        id: 0,
        name: 'checkbox',
        label: '',
        props: {
            width: '40px',
        },
    },
    {
        id: 1,
        name: 'number',
        label: 'Номер рапорта/извещения',
        props: {
            width: '120px',
        },
    },
    {
        id: 2,
        name: 'name',
        label: 'Наименование',
    },
    {
        id: 4,
        name: 'current_documentation',
        label: 'Действующая документация',
    },
    {
        id: 5,
        name: 'presentations',
        label: 'Дата предъявления',
        props: {
            width: '250px',
        },
    },
    {
        id: 6,
        name: 'closing_date',
        label: 'Дата закрытия',
        props: {
            width: '100px',
        },
    },
    {
        id: 7,
        name: 'files',
        label: 'Файлы и фотографии',
        props: {
            width: '300px',
        },
    },
]